module.exports = "<div ng-if=\"vm.showIcp &amp;&amp; vm.icp\" class=icp>{{vm.icp}}</div>";


//////////////////
// WEBPACK FOOTER
// ./components/icp/icp.jade
// module id = 271
// module chunks = 0